<template>
  <div class="songpagecategory">
    <div class="comp-title ml-2">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Thể loại
        </h1>
      </div>
    </div>
    <div style="clear: both; margin-bottom: 1rem;"></div>

    <div class="row">
      <div v-for="(country, index) in dataCountry" v-if="country.name.toUpperCase() != 'Khác'.toUpperCase()" class="col-md-12 text-left country">
        <h4 class="text-uppercase color-blue font-size-18 float-left countryname d-block">{{ country.name}}</h4>
        <div class="row d-block">
          <div v-for="(category, indexCategory) in country.category" class="item col-xs-3 float-left pr-3">
            <a href="javascript:void(0)" class="color-text" :class="{active : currentCate === category.code}" @click="filterData(category.code)">
              <span class="fa fa-angle-double-right"></span> {{ category.name}}
            </a>
          </div>
        </div>
      </div>

      <div v-for="(country, index) in dataCountry" v-if="country.name.toUpperCase() == 'Khác'.toUpperCase()" class="col-md-12 text-left country">
        <h4 class="text-uppercase color-blue font-size-18 float-left countryname d-block">{{ country.name}}</h4>
        <div class="row d-block">
          <div v-for="(category, indexCategory) in country.category" class="item col-xs-3 float-left pr-3">
            <a href="javascript:void(0)" class="color-text" :class="{active : currentCate === category.code}" @click="filterData(category.code)">
              <span class="fa fa-angle-double-right"></span> {{ category.name}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Category",
    props: {
      
    },
    data () {
      return {
        currentCate: "POXW",
        dataCountry: [
          /*{
            "countryName": "Việt Nam",
            "category": [
              { "catname": "Nhạc trẻ", "code": "nt" },
              { "catname": "Trữ tình", "code": "t" },
              { "catname": "Remix Việt", "code": "h" }
            ]
          },
          {
            "countryName": "Âu Mỹ",
            "category": [
              { "catname": "Pop", "code": "p" },
              { "catname": "Rock", "code": "r" },
              { "catname": "Blue", "code": "b" }
            ]
          },
          {
            "countryName": "Châu Á",
            "category": [
              { "catname": "Hàn Quốc", "code": "hq" },
              { "catname": "Nhật Bản", "code": "nb" },
              { "catname": "Thái Lan", "code": "tl" }
            ]
          },
          {
            "countryName": "Khác",
            "category": [
              { "catname": "Thiếu nhi", "code": "tn" },
              { "catname": "Không lời", "code": "kl" },
              { "catname": "Beat", "code": "be" }
            ]
          }*/
        ]
      }
    },
    methods: {
      getListCategory(){
        axios.post(api.songCategoryList)
          .then(response => {
            this.dataCountry = response.data.result;
          })
          .catch(e => {
            console.log("Song list category----");
            console.log(e);
          });
      },
      filterData(catecode){
        this.currentCate = catecode;
        this.$router.push({ path: this.$router.path, query: { c: catecode } })
        //Gửi category code lên component cha là component song
        this.$emit("categoryCodeToParent", catecode);
      }
    },
    watch: {
      "$route.path": {
        handler: function(val){
          if(this.$route.query.c && this.$route.query.c != undefined){
            this.currentCate = this.$route.query.c;
          }
          this.getListCategory();
          this.$emit("categoryCodeToParent", this.currentCate);
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .item{
    margin-bottom: 1rem;
  }
  .countryname{
    width: 100%;
  }
  .country a.active{
    color: #0d5bdd !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/song/wap/Category.vue